import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import {
  accountIdMismatchValidatorName,
  amazonBedrockIamRoleArnValidatorName,
  certificatePrivateKeyValidatorName,
  certificateThumbprintValidatorName,
  chatGptEnterpriseApiKeyValidatorName,
  DomainValidatorName,
  guidValidatorName,
  NoSpaceValidatorName,
  salesforceInstanceUrlValidatorName,
  serviceNowInstanceUrlValidatorName,
} from 'src/app/common/appValidators';
import { LabelsProviderPipe } from '../labels-provider/labels-provider.pipe';

@Pipe({
  name: 'formErrorMessage',
})
export class FormErrorMessagePipe implements PipeTransform {
  constructor(private readonly _labelsProviderPipe: LabelsProviderPipe) {}

  public transform(errors: ValidationErrors): string {
    if (errors['required']) {
      return this._labelsProviderPipe.transform('formErrors.requiredFormFieldMsg');
    }

    if (errors['email']) {
      return this._labelsProviderPipe.transform('formErrors.emailFormFieldMsg');
    }

    if (errors[NoSpaceValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.noSpaceFormFieldMsg');
    }

    if (errors[guidValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.guidFormFieldMsg');
    }

    if (errors[DomainValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.domainFormFieldMsg');
    }

    if (errors[certificateThumbprintValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.certificateThumbprintFormFieldMsg');
    }

    if (errors[certificatePrivateKeyValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.certificatePrivateKeyFormFieldMsg');
    }

    if (errors[salesforceInstanceUrlValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.salesforceInstanceUrlFormFieldMsg');
    }

    if (errors[serviceNowInstanceUrlValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.serviceNowInstanceUrlFormFieldMsg');
    }

    if (errors[chatGptEnterpriseApiKeyValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.chatGptEnterpriseApiKeyFormFieldMsg');
    }

    if (errors[amazonBedrockIamRoleArnValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.amazonBedrockIamRoleArnFormFieldMsg');
    }

    if (errors[accountIdMismatchValidatorName]) {
      return this._labelsProviderPipe.transform('formErrors.accountIdMismatchFormFieldMsg');
    }

    return this._labelsProviderPipe.transform('');
  }
}
